// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__296_o","content":"styles_content__1wjLt"};